/* src/components/Profile/ProfileTabs.jsx */
import React from 'react';
import './ProfileComponents.css';

const ProfileTabs = ({ activeTab, setActiveTab, showFriendsTab = true }) => {
    return (
        <div className="profile-tabs">
            <button
                className={activeTab === 'posts' ? 'active' : ''}
                onClick={() => setActiveTab('posts')}
            >
                Posts
            </button>

            <button
                className={activeTab === 'about' ? 'active' : ''}
                onClick={() => setActiveTab('about')}
            >
                About
            </button>

            {showFriendsTab && (
                <button
                    className={activeTab === 'friends' ? 'active' : ''}
                    onClick={() => setActiveTab('friends')}
                >
                    {/* Just "Friends" for generic use, or pass a prop for specific label */}
                    Friends
                </button>
            )}
        </div>
    );
};

export default ProfileTabs;